(function maintenanceIntro() {
  const root = document.getElementById('maintenance-intro-root');
  if (!root) return;

  const html = document.documentElement;
  html.classList.add('maintenance-intro-locked');

  const focusableSelector =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  function getFocusableElements() {
    return Array.from(root.querySelectorAll(focusableSelector)).filter(
      (element) => !element.hasAttribute('disabled') && element.offsetParent !== null
    );
  }

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements();
    if (focusable.length === 0) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const initialFocus = getFocusableElements()[0];
  if (initialFocus) {
    initialFocus.focus();
  } else {
    root.setAttribute('tabindex', '-1');
    root.focus();
  }
})();
